import { useState } from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useGiftData } from "../../../lib/useMockData";

export default function GiftTypesSection() {
  const { giftTypesData } = useGiftData();
  const [activeType, setActiveType] = useState(giftTypesData.types[0].id);
  const active = giftTypesData.types.find((t) => t.id === activeType)!;

  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="section-label mb-2">{giftTypesData.label}</p>
              <h2 className="section-title">{giftTypesData.title}</h2>
              <p className="section-subtitle max-w-xl mx-auto">
                {giftTypesData.subtitle}
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={100}>
            <div className="flex flex-wrap justify-center gap-3 mb-10">
              {giftTypesData.types.map((t) => (
                <button
                  key={t.id}
                  onClick={() => setActiveType(t.id)}
                  className={`px-5 py-2.5 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap ${
                    activeType === t.id
                      ? "bg-airdoa-navy text-white"
                      : "bg-white text-airdoa-gray border border-airdoa-gray-light/50 hover:border-airdoa-gold"
                  }`}
                >
                  {t.name}
                  {t.popular && (
                    <span className="ml-1.5 text-[10px] text-airdoa-gold font-bold">
                      ★人気
                    </span>
                  )}
                </button>
              ))}
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={150}>
            <div className="bg-airdoa-cream rounded-xl overflow-hidden border border-airdoa-gray-light/30">
              <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="aspect-[4/3] lg:aspect-auto overflow-hidden">
                  <img
                    src={active.image}
                    alt={active.name}
                    className="w-full h-full object-cover object-top transition-transform duration-700"
                  />
                </div>
                <div className="p-6 md:p-10 flex flex-col">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="px-2.5 py-1 text-[11px] font-medium text-airdoa-navy bg-airdoa-gold rounded">
                      {active.tag}
                    </span>
                    <span className="text-sm text-airdoa-gray">
                      {active.duration}
                    </span>
                  </div>
                  <h3 className="text-xl md:text-2xl font-serif font-semibold text-airdoa-navy mb-2">
                    {active.name}
                  </h3>
                  <p className="text-sm text-airdoa-gray mb-5">
                    コース：{active.route}
                  </p>

                  <div className="mb-5">
                    <p className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-2">
                      見どころ
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {active.highlights.map((h) => (
                        <span
                          key={h}
                          className="px-3 py-1.5 text-xs text-airdoa-navy bg-white rounded-full border border-airdoa-gray-light/40"
                        >
                          {h}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="mb-6">
                    <p className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-2">
                      同封物
                    </p>
                    <ul className="space-y-1.5">
                      {active.includes.map((inc) => (
                        <li
                          key={inc}
                          className="flex items-center gap-2 text-sm text-airdoa-gray"
                        >
                          <span className="w-4 h-4 flex items-center justify-center text-airdoa-gold">
                            <i className="ri-check-line" />
                          </span>
                          {inc}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <Link
                    to="/contact"
                    className="mt-auto btn-primary w-full text-center justify-center"
                  >
                    このプランを問い合わせる
                    <span className="w-4 h-4 flex items-center justify-center ml-1.5">
                      <i className="ri-arrow-right-line" />
                    </span>
                  </Link>
                </div>
              </div>
            </div>

            <div className="mt-6 bg-airdoa-navy/5 rounded-lg p-4 md:p-5">
              <p className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-2">
                NOTES
              </p>
              <ul className="space-y-1.5">
                {giftTypesData.notes.map((n, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-2 text-sm text-airdoa-gray"
                  >
                    <span className="w-4 h-4 flex items-center justify-center text-airdoa-gold mt-0.5 shrink-0">
                      <i className="ri-information-line" />
                    </span>
                    {n}
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}